export function getStoreScopedRedirectPath(teamId: string, path: string) {
  const prefix = `/stores/${teamId}`;

  // Tolerate callers that already included `/stores/<teamId>` in the path.
  if (path === prefix) {
    return prefix;
  }
  if (path.startsWith(`${prefix}/`)) {
    return path;
  }
  return prefix + path;
}
